import type { Networkish } from "@/types";
import React, { type Dispatch, type SetStateAction, useCallback, useEffect, useMemo, useState } from "react";

import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { SupButton, SupLoader } from "@repo/core-ui";
import { classNames, UiLabelChain } from "@/utils";

interface Web3CommonSwitchNetworkProps {
  targetChainId: number;
  isFluid?: boolean;
  setConnectedWalletChain?: Dispatch<SetStateAction<Networkish | undefined>>;
}

export default function Web3CommonSwitchNetwork({ targetChainId, setConnectedWalletChain, isFluid = true }: Web3CommonSwitchNetworkProps) {
  const { primaryWallet, network } = useDynamicContext();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (parseInt(`${network}`) === targetChainId) {
      setIsLoading(false);
      setConnectedWalletChain?.(targetChainId);
    }
  }, [network, setConnectedWalletChain, targetChainId]);

  const notAllowed = useMemo(() => {
    return isLoading || !primaryWallet;
  }, [isLoading, primaryWallet]);

  const prefixIcon = isLoading ? <SupLoader isSmall color="primary" className="text-neutral-700" svgClassName="stroke-2" /> : undefined;

  const onClickHandler = useCallback(() => {
    setIsLoading(true);
    primaryWallet?.connector?.switchNetwork({ networkChainId: targetChainId as number }).catch(() => setIsLoading(false));
  }, [primaryWallet, targetChainId]);

  return (
    <SupButton
      className={classNames(notAllowed && "cursor-not-allowed", isFluid && "w-full justify-center")}
      disabled={notAllowed}
      variant="outlined"
      prefixIcon={prefixIcon}
      onClickCapture={onClickHandler}
    >
      <div className="flex w-full items-center space-x-2">
        <span>Switch to</span>
        {UiLabelChain(targetChainId as number, true, true, false, "border-0 p-0 leading-[20px]")}
      </div>
    </SupButton>
  );
}
